import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["card", "filterBtn"]

  declare readonly cardTargets: HTMLElement[]
  declare readonly filterBtnTargets: HTMLElement[]

  filterAll(): void {
    // 모든 카드 표시
    this.cardTargets.forEach(card => {
      card.classList.remove("hidden")
    })

    // 버튼 상태 업데이트
    this.updateButtonStates(null)
  }

  filter(event: Event): void {
    const button = event.currentTarget as HTMLElement
    const series = button.dataset.series

    // 필터링
    this.cardTargets.forEach(card => {
      const cardSeries = card.dataset.series
      if (cardSeries === series) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })

    // 버튼 상태 업데이트
    this.updateButtonStates(series)
  }

  private updateButtonStates(activeSeries: string | null): void {
    this.filterBtnTargets.forEach(btn => {
      const btnSeries = btn.dataset.series

      if ((activeSeries === null && !btnSeries) || btnSeries === activeSeries) {
        // 활성화 상태
        btn.classList.remove("bg-white/10", "text-slate-300", "hover:bg-white/20")
        btn.classList.add("bg-wl-pink", "text-white", "shadow-lg", "shadow-wl-pink/30")
        btn.dataset.active = "true"
      } else {
        // 비활성화 상태
        btn.classList.remove("bg-wl-pink", "text-white", "shadow-lg", "shadow-wl-pink/30")
        btn.classList.add("bg-white/10", "text-slate-300", "hover:bg-white/20")
        btn.dataset.active = "false"
      }
    })
  }
}
